import React from "react";
import classNames from "classnames";
import { CardHeaderProps } from "../../../types/components/Card";

const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  titleWeight,
  subtitle,
  icon,
  actions,
  noDivider,
  plain,
  className,
  as: Heading = 'h2',
  id,
}) => {
  if (!title && !icon && !actions && !subtitle) return null;

  return (
    <div
      className={classNames(
        'bwp-card__header',
        {
          'bwp-card__header--no-divider': noDivider,
          'bwp-card__header--plain': plain,
        },
        className,
      )}
    >
      {icon && (
        <span className="bwp-card__header-icon" aria-hidden="true">
          {icon}
        </span>
      )}

      {(title || subtitle) && (
        <div className="bwp-card__header-text">
          {title && (
            <Heading
              className={classNames('bwp-card__title', {
                'bwp-card__title--strong': titleWeight === 'strong',
              })}
            >
              {title}
            </Heading>
          )}
          {subtitle && <p className="bwp-card__subtitle">{subtitle}</p>}
        </div>
      )}

      {actions && <div className="bwp-card__header-actions">{actions}</div>}
    </div>
  );
};
export default CardHeader;